import { jsx } from "react/jsx-runtime";
import { ConfigProvider } from "antd";
import { WeetTokensProvider } from "./context.js";
import "./weet-css-vars.css";
import { tokens } from "./weet-tokens.js";
import { configProviderProps } from "./theme.js";
import { ToastProvider } from "../components/toast/provider.js";
ConfigProvider.config({
    holderRender: (children)=>/*#__PURE__*/ jsx(ConfigProvider, {
            ...configProviderProps,
            children: children
        })
});
function WeetProvider(props) {
    const { children } = props;
    return /*#__PURE__*/ jsx(WeetTokensProvider, {
        value: {
            tokens: tokens
        },
        children: /*#__PURE__*/ jsx(ConfigProvider, {
            ...configProviderProps,
            children: /*#__PURE__*/ jsx(ToastProvider, {
                children: children
            })
        })
    });
}
export { WeetProvider as default };
